import httpService from '@/api/httpService'

const RegionsApi = (() => {
  const apiPostfix = 'documents'

  return {
    apiPostfix: apiPostfix,

    async getDocuments () {
      const response = await httpService.get(`delivery/${apiPostfix}/regions`)
      return response.data
    }
  }
})()

export default RegionsApi
